import NotFoundHeader from '../components/404/NotFoundHeader';
import '../components/404/404.css';

const NotFound = () => {
  return (
    <>
      <NotFoundHeader />{' '}
    </>
  );
};

export default NotFound;
